<template>
  <v-card>
    <v-toolbar
        color="primary"
        dark
        flat
    >
      <v-toolbar-title>{{title}}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon dark @click="cancel">
        <v-icon>{{icons.mdiClose}}</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text>
      <v-form>
        <v-container>
          <v-row>
            <v-col cols="12" md="4">
              <v-text-field
                  v-model="form.number"
                  label="Номер доверенности"
                  required
                  :error-messages="numberErrors"
                  @blur="$v.form.number.$touch()"
                  :counter="50"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-menu
                  :close-on-content-click="false"
                  v-model="dateMenu"
                  transition="scale-transition"
                  offset-y
                  :nudge-right="40"
                  max-width="290px"
                  min-width="290px"
              >
                <template v-slot:activator="{on}">
                  <v-text-field
                      label="Дата выдачи"
                      v-model="form.startDate"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                      :error-messages="startDateErrors"
                  />
                </template>
                <v-date-picker
                    v-model="form.startDate"
                    no-title
                    scrollable
                    locale="ru"
                    first-day-of-week="1"
                    @change="dateMenu = false"
                />
              </v-menu>
            </v-col>
            <v-col cols="12" md="4">
              <v-menu
                  :close-on-content-click="false"
                  v-model="expireDateMenu"
                  transition="scale-transition"
                  offset-y
                  :nudge-right="40"
                  max-width="290px"
                  min-width="290px"
              >
                <template v-slot:activator="{on}">
                  <v-text-field
                      label="Действительна по"
                      v-model="form.endDate"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                      :error-messages="endDateDateErrors"
                  />
                </template>
                <v-date-picker
                    v-model="form.endDate"
                    no-title
                    scrollable
                    locale="ru"
                    first-day-of-week="1"
                    @change="expireDateMenu = false"
                />
              </v-menu>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4">
              <v-text-field
                  v-model="form.position"
                  label="Должность"
                  required
                  :counter="400"
                  :error-messages="positionErrors"
                  @blur="$v.form.position.$touch()"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                  v-model="form.fullName"
                  label="Ф.И.О"
                  required
                  :error-messages="fullNameErrors"
                  @blur="$v.form.fullName.$touch()"
                  :counter="500"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                  label="Инн сотрудника"
                  type="number"
                  v-model="form.personInn"
                  :error-messages="personInnErrors"
                  :counter="9"
                  @blur="$v.form.personInn.$touch()"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="3">
              <v-text-field
                  label="Пасспорт серия"
                  type="text"
                  v-model="form.passportSerial"
                  :error-messages="passportSerialErrors"
                  :counter="50"
                  @blur="$v.form.passportSerial.$touch()"
              />
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                  label="Номер пасспорта"
                  type="text"
                  v-model="form.passportNumber"
                  :error-messages="passportNumberErrors"
                  :counter="50"
                  @blur="$v.form.passportNumber.$touch()"
              />
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                  label="Пасспорт кем выдан"
                  type="text"
                  v-model="form.passportIssuer"
                  :error-messages="passportIssuerErrors"
                  :counter="200"
                  @blur="$v.form.passportIssuer.$touch()"
              />
            </v-col>
            <v-col cols="12" md="3">
              <v-menu
                  :close-on-content-click="false"
                  v-model="passportIssueDateMenu"
                  transition="scale-transition"
                  offset-y
                  :nudge-right="40"
                  max-width="290px"
                  min-width="290px"
              >
                <template v-slot:activator="{on}">
                  <v-text-field
                      label="Дата выдачи"
                      v-model="form.passportIssuedOn"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                      :error-messages="passportIssuedOnErrors"
                  />
                </template>
                <v-date-picker
                    v-model="form.passportIssuedOn"
                    no-title
                    scrollable
                    locale="ru"
                    first-day-of-week="1"
                    @change="passportIssueDateMenu = false"
                />
              </v-menu>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="3">
              <v-text-field
                  label="Инн контрагента"
                  type="number"
                  v-model="form.contractorInn"
                  :error-messages="contractorInnErrors"
                  :counter="9"
                  @blur="$v.form.contractorInn.$touch()"
              />
            </v-col>

            <v-col cols="12" md="3">
              <v-text-field
                  label="Наименования контрагента"
                  type="text"
                  v-model="form.contractorName"
                  :error-messages="contractorNameErrors"
                  :counter="500"
                  @blur="$v.form.contractorName.$touch()"
              />
            </v-col>

            <v-col cols="12" md="3">
              <v-text-field
                  label="Номер договора"
                  type="text"
                  v-model="form.contractNumber"
                  :error-messages="contractNumberErrors"
                  :counter="200"
                  @blur="$v.form.contractNumber.$touch()"
              />
            </v-col>
            <v-col cols="12" md="3">
              <v-menu
                  :close-on-content-click="false"
                  v-model="contractDateMenu"
                  transition="scale-transition"
                  offset-y
                  :nudge-right="40"
                  max-width="290px"
                  min-width="290px"
              >
                <template v-slot:activator="{on}">
                  <v-text-field
                      label="Дата контракта"
                      v-model="form.contractDate"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                  />
                </template>
                <v-date-picker
                    v-model="form.contractDate"
                    no-title
                    scrollable
                    locale="ru"
                    first-day-of-week="1"
                    @change="contractDateMenu = false"
                />
              </v-menu>
            </v-col>
          </v-row>

          <p class="subtitle-1 font-weight-bold mb-2 mt-5 d-flex">Перечень материальных ценностей,
            подлежащих получению
            <v-spacer/>
            <v-btn color="blue darken-1" text @click="addItem()">Добавить груз</v-btn>
          </p>
          <v-simple-table
              :fixed-header="true"
              :dense="true"
          >
            <template v-slot:default>
              <thead>
              <tr>
                <th class="text-center">#</th>
                <th class="text-left">Товар</th>
                <th class="text-center">Единица измерения</th>
                <th class="text-center" colspan="2">Количество</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, index) in form.items">
                <td class="text-center">{{ index + 1 }}</td>
                <td class="text-left">
                  <v-text-field
                      v-model="item.product"
                      class="py-0"
                      :error-messages="getItemProductErrors(index)"
                      :ref="`item_${index}_product`"
                      @keyup.enter.exact="$refs[`item_${index}_measurement`][0].focus()"
                      :counter="500"
                      @blur="$v.form.items.$each[index].product.$touch()"
                  />
                </td>
                <td class="text-center">
                  <v-text-field
                      v-model="item.measurement"
                      class="py-0"
                      :error-messages="getItemMeasurementErrors(index)"
                      :ref="`item_${index}_measurement`"
                      @keyup.enter.exact="$refs[`item_${index}_quantity`][0].focus()"
                      :counter="100"
                      @blur="$v.form.items.$each[index].measurement.$touch()"
                  />
                </td>
                <td class="text-center">
                  <v-text-field
                      v-model="item.quantity"
                      class="py-0"
                      type="number"
                      :error-messages="getItemQuantityErrors(index)"
                      :ref="`item_${index}_quantity`"
                      @keyup.enter.exact="() => {
                                                if ($refs[`item_${(index +1)}_product`])
                                                    $refs[`item_${(index +1)}_product`][0].focus()
                                            }"
                      @focus="() => {
                                            if (item.quantity === 0)
                                                item.quantity = '';
                                        }"
                      @blur="() => {
                                            if (item.quantity.toString().trim() === '')
                                                item.quantity = 0;
                                            else
                                                item.quantity = +item.quantity;
                                            $v.form.items.$each[index].quantity.$touch();
                                        }"
                  />
                </td>
                <td class="text-center">
                  <v-icon small @click="onRemoveItemClicked(index)">
                    delete
                  </v-icon>
                </td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
          <v-dialog
              v-model="deleteItemDialog"
              max-width="480"
              :persistent="true"
          >
            <v-card>
              <v-card-title class="headline">
                Подтведите удаление
              </v-card-title>
              <v-card-text>
                После удаления, восстановить можно будет только вручным вводом
              </v-card-text>

              <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-btn
                    color="warning darken-1"
                    text
                    @click="() => { deleteItemDialog = false; deletingItemIndex = null; }"
                >
                  Отменить
                </v-btn>
                <v-btn
                    color="error darken-1"
                    text
                    @click="() => { deleteItem(deletingItemIndex); deleteItemDialog = false; } "
                >
                  Удалить
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-row>
            <v-col class="text-right">
              <v-btn @click="cancel" class="mr-4">Отменить</v-btn>
              <v-btn @click="submit"
                     color="primary"
                     :loading="loading"
                     :disabled="loading">
                Сохранить
                <template v-slot:loader>
                  <span>Загрузка...</span>
                </template>
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-card-text>
  </v-card>
</template>
<script>
import {validationMixin} from 'vuelidate'
import {required, maxLength, minValue, decimal} from 'vuelidate/lib/validators';
import {validInn} from "@/js/custom-validators";

import _ from 'underscore'
import moment from 'moment'
import {mdiClose} from "@mdi/js";

export default {
  name: "CompanyAttornetForm",
  props: ['title'],
  mixins: [validationMixin],
  data() {
    return {
      loading: false,
      icons: {
        mdiClose
      },
      form: {
        number: '',
        startDate: null,
        endDate: null,

        position: null,
        fullName: '',
        personInn: '',

        passportSerial: '',
        passportNumber: '',
        passportIssuer: '',
        passportIssuedOn: '',

        contractorInn: '',
        contractorName: '',
        contractNumber: null,
        contractDate: null,

        items: []
      },
      dateMenu: false,
      expireDateMenu: false,
      passportIssueDateMenu: false,
      contractDateMenu: false,

      deleteItemDialog: false,
      deletingItemIndex: null,
    }
  },
  validations: {
    form: {
      number: {
        required,
        maxLength: maxLength(50)
      },
      startDate: {
        required
      },
      endDate: {
        required
      },

      position: {
        required,
        maxLength: maxLength(400)
      },
      fullName: {
        required,
        maxLength: maxLength(500)
      },
      personInn: {
        required,
        formatInn: validInn
      },

      passportSerial: {
        required,
        maxLength: maxLength(50)
      },
      passportNumber: {
        required,
        maxLength: maxLength(50)
      },
      passportIssuer: {
        required,
        maxLength: maxLength(50)
      },
      passportIssuedOn: {
        required,
      },

      contractorInn: {
        required,
        formatInn: validInn
      },
      contractorName: {
        required,
        maxLength: maxLength(500)
      },
      contractNumber: {
        required,
        maxLength: maxLength(200)
      },

      items: {
        required,
        $each: {
          product: {
            required,
            maxLength: maxLength(500)
          },
          measurement: {
            required,
            maxLength: maxLength(100)
          },
          quantity: {
            required,
            decimal,
            minValue: minValue(0)
          }
        }
      }
    }
  },
  computed: {
    numberErrors() {
      const errors = [];
      if (this.$v.form.number.$dirty)
        if (!this.$v.form.number.required)
          errors.push('Обязательно');
        else
          !this.$v.form.number.maxLength && errors.push('Слишком длинное');
      return errors;
    },
    startDateErrors() {
      const errors = [];

      if (this.$v.form.startDate.$dirty)
        if (!this.$v.form.startDate.required)
          errors.push('Обязательно');
      return errors;
    },
    endDateDateErrors() {
      const errors = [];

      if (this.$v.form.endDate.$dirty)
        if (!this.$v.form.endDate.required)
          errors.push('Обязательно');
      return errors;
    },
    positionErrors() {
      const errors = [];

      if (this.$v.form.position.$dirty)
        if (!this.$v.form.position.required)
          errors.push('Обязательно');
        else
          !this.$v.form.position.maxLength && errors.push('Слишком длинное');
      return errors;
    },
    fullNameErrors() {
      const errors = [];

      if (this.$v.form.fullName.$dirty)
        if (!this.$v.form.fullName.required)
          errors.push('Обязательно');
        else
          !this.$v.form.fullName.maxLength && errors.push('Слишком длинное');
      return errors;
    },
    personInnErrors() {
      const errors = [];

      if (this.$v.form.personInn.$dirty)
        if (!this.$v.form.personInn.required)
          errors.push('Обязательно');
        else
          !this.$v.form.personInn.formatInn && errors.push('Неправильный формат');
      return errors;
    },

    passportSerialErrors() {
      const errors = [];

      if (this.$v.form.passportSerial.$dirty)
        if (!this.$v.form.passportSerial.required)
          errors.push('Обязательно');
        else
          !this.$v.form.passportSerial.maxLength && errors.push('Слишком длинное');
      return errors;
    },
    passportNumberErrors() {
      const errors = [];

      if (this.$v.form.passportNumber.$dirty)
        if (!this.$v.form.passportNumber.required)
          errors.push('Обязательно');
        else
          !this.$v.form.passportNumber.maxLength && errors.push('Слишком длинное');
      return errors;
    },
    passportIssuerErrors() {
      const errors = [];

      if (this.$v.form.passportIssuer.$dirty)
        if (!this.$v.form.passportIssuer.required)
          errors.push('Обязательно');
        else
          !this.$v.form.passportIssuer.maxLength && errors.push('Слишком длинное');
      return errors;
    },
    passportIssuedOnErrors() {
      const errors = [];
      if (this.$v.form.passportIssuedOn.$dirty)
        if (!this.$v.form.passportIssuedOn.required)
          errors.push('Обязательно');
      return errors;
    },

    contractorInnErrors() {
      const errors = [];

      if (this.$v.form.contractorInn.$dirty)
        if (!this.$v.form.contractorInn.required)
          errors.push('Обязательно');
        else
          !this.$v.form.contractorInn.formatInn && errors.push('Неправильный формат');
      return errors;
    },
    contractorNameErrors() {
      const errors = [];

      if (this.$v.form.contractorName.$dirty)
        if (!this.$v.form.contractorName.required)
          errors.push('Обязательно');
        else
          !this.$v.form.contractorName.maxLength && errors.push('Слишком длинное');
      return errors;
    },
    contractNumberErrors() {
      const errors = [];

      if (this.$v.form.contractNumber.$dirty)
        if (!this.$v.form.contractNumber.required)
          errors.push('Обязательно');
        else
          !this.$v.form.contractNumber.maxLength && errors.push('Слишком длинное');
      return errors;
    },

  },
  methods: {
    deleteItem(index) {
      if (typeof (index) === 'number'
          && index >= 0
          && index < this.form.items.length
      )
        this.form.items = _.filter(this.form.items, (item, itemIndex) => {
          return itemIndex !== index;
        });
    },
    onRemoveItemClicked(index) {
      this.deletingItemIndex = index;
      this.deleteItemDialog = true;
    },

    getItemProductErrors(index) {
      const errors = [];
      if (this.$v.form.items.$each[index].product.$dirty) {
        if (!this.$v.form.items.$each[index].product.required)
          errors.push('Обязательно');
        else
          !this.$v.form.items.$each[index].product.maxLength && errors.push('Слишком длинное');
      }
      return errors;
    },
    getItemMeasurementErrors(index) {
      const errors = [];
      if (this.$v.form.items.$each[index].measurement.$dirty) {
        if (!this.$v.form.items.$each[index].measurement.required)
          errors.push('Обязательно');
        else
          !this.$v.form.items.$each[index].measurement.maxLength && errors.push('Слишком длинное');
      }
      return errors;
    },
    getItemQuantityErrors(index) {
      const errors = [];
      if (this.$v.form.items.$each[index].quantity.$dirty) {
        if (!this.$v.form.items.$each[index].quantity.required)
          errors.push('Обязательно');
        else {
          !this.$v.form.items.$each[index].quantity.decimal && errors.push('Введите число');
          !this.$v.form.items.$each[index].quantity.minValue && errors.push('Отрицальное число введено');
        }
      }
      return errors;
    },

    addItem() {
      this.form.items.push({
        product: '',
        measurement: '',
        quantity: 0
      });
    },
    cancel() {
      this.$emit('cancel');
    },

    getFormData() {
      return {
        number: this.form.number,
        startDate: this.form.startDate,
        endDate: this.form.endDate,

        position: this.form.position,
        fullName: this.form.fullName,
        personInn: this.form.personInn,

        passportSerial: this.form.passportSerial,
        passportNumber: this.form.passportNumber,
        passportIssuer: this.form.passportIssuer,
        passportIssuedOn: this.form.passportIssuedOn,

        contractorInn: this.form.contractorInn,
        contractorName: this.form.contractorName,
        contractNumber: this.form.contractNumber,
        contractDate: this.form.contractDate,

        items: this.form.items,
      }
    },
    clear() {
      this.loading = false;
      this.form.number = '';
      this.form.startDate = moment().format('YYYY-MM-DD');
      this.form.endDate = null;

      this.form.position = null;
      this.form.fullName = '';
      this.form.personInn = '';

      this.form.passportSerial = '';
      this.form.passportNumber = '';
      this.form.passportIssuer = '';
      this.form.passportIssuedOn = '';

      this.form.contractorInn = '';
      this.form.contractorName = '';
      this.form.contractNumber = null;
      this.form.contractDate = null;

      this.form.items = [];

      this.$v.$reset();
    },
    submit() {
      this.$v.form.$touch();
      if (this.form.items.length === 0) {
        this.addItem();
        this.$v.form.$touch();
      }
      if (!this.$v.form.$invalid) {
        this.loading = true;
        this.$emit('submit');
      }
    },
    hideLoading() {
      this.loading = false;
    },
    setAttorney(attorney, attorneyItems) {
      this.form.number = attorney.number;
      this.form.startDate = attorney.start;
      this.form.endDate = attorney.end;

      this.form.position = attorney.position;
      this.form.fullName = attorney.fullName;
      this.form.personInn = attorney.personInn;

      this.form.passportSerial = attorney.passportSerial;
      this.form.passportNumber = attorney.passportNumber;
      this.form.passportIssuer = attorney.passportIssuer;
      this.form.passportIssuedOn = attorney.passportIssuedOn;

      this.form.contractorInn = attorney.contractorInn;
      this.form.contractorName = attorney.contractorName;
      this.form.contractNumber = attorney.contractNumber;
      this.form.contractDate = attorney.contractDate;
      this.form.items = attorneyItems;
    },
  },
  created() {
    this.clear();
    this.addItem();
  }
}
</script>